/**
 * Application Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

const enablePwaInDev = process.env.REACT_APP_ENABLE_PWA_DEV === 'true';
const shouldRegisterPwa = process.env.NODE_ENV === 'production' || enablePwaInDev;

if (shouldRegisterPwa) {
  serviceWorkerRegistration.register({
    onSuccess: () => {
      console.log('[PWA] Content is cached for offline use.');
    },
    onUpdate: () => {
      // Keep update handling non-disruptive to avoid auth flow churn.
      console.log('[PWA] New content is available. Refresh manually when convenient.');
    }
  });
} else {
  serviceWorkerRegistration.unregister();
}
